import { AxiosResponse, Canceler } from 'axios';
import settings from '../settings';
import { DateString, IApiResult, IPaginationResponseDto, ITransferContract, TransferContractDealType } from '../types';
import api from './base';

export enum TransferContractsOrder {
  Newest = 'newest',
  Oldest = 'oldest',
}

export enum TransferContractsSearchType {
  Username = 'username',
  StoryTitle = 'storyTitle',
  StoryId = 'storyId',
  SeasonId = 'seasonId',
  WriterName = 'writerName',
  UserId = 'writerId',
}

export interface IFetchTransferContractsParams {
  isToBeTerminated: boolean;
  startDate: DateString;
  endDate: DateString;
  order: TransferContractsOrder;
  searchType?: TransferContractsSearchType;
  dealType?: TransferContractDealType;
  searchKey?: string;
}

export function fetchTransferContracts(
  page: number,
  limit: number,
  params: IFetchTransferContractsParams,
): [Promise<AxiosResponse<IPaginationResponseDto<ITransferContract>>>, Canceler] {
  const uri = `${settings.getApiURI()}/transfer-admin/v1/contracts`;

  return api.getWithCancel(uri, {
    params: {
      page,
      limit,
      ...params,
    },
  });
}

export function fetchTransferContractsBySeasonId(seasonId: number): [Promise<AxiosResponse<ITransferContract[]>>, Canceler] {
  const uri = `${settings.getApiURI()}/transfer-admin/v1/seasons/${seasonId}/contracts`;

  return api.getWithCancel(uri);
}

export function fetchTransferContract(id: number): [Promise<AxiosResponse<ITransferContract>>, Canceler] {
  const uri = `${settings.getApiURI()}/transfer-admin/v1/contracts/${id}`;

  return api.getWithCancel(uri);
}

export function downloadTransferContracts(params: IFetchTransferContractsParams): Promise<AxiosResponse<any>> {
  const uri = `${settings.getApiURI()}/transfer-admin/v1/download-contracts`;

  return api.http.get(uri, {
    params,
  });
}

export function createTransferContract(contract: Partial<ITransferContract>): Promise<AxiosResponse<IApiResult<ITransferContract>>> {
  const { storyId, seasonId, writerId } = contract;

  const destPath = writerId ? `writers/${writerId}` : storyId ? `stories/${storyId}` : `seasons/${seasonId}`;

  const uri = `${settings.getApiURI()}/transfer-admin/v1/${destPath}/contracts`;

  return api.http.post(uri, contract);
}

export function updateTransferContract(id: number, contract: Partial<ITransferContract>): Promise<AxiosResponse<IApiResult<ITransferContract>>> {
  const uri = `${settings.getApiURI()}/transfer-admin/v1/contracts/${id}`;

  return api.http.put(uri, contract);
}

export function deleteTransferContract(id: number): Promise<AxiosResponse<IApiResult<ITransferContract>>> {
  const uri = `${settings.getApiURI()}/transfer-admin/v1/contracts/${id}`;

  return api.http.delete(uri);
}
